import SpecialText from '../fragments/SpecialText';
import { useReveal } from '../hooks/UseReveal';
import { useState, useEffect } from "react";

export default function Text({ block }) {

    const textRevealRef = useReveal({ once: true });

    return (
        <div className={`c-page__block c-page__block--text`}>
            <div className={`l-grid c-transition-in`} ref={textRevealRef}>
                <div className={`l-grid__col l-grid__col--m-5-12 l-grid__col--l-5-12`} >
                    <h1 className="c-overview__title">
                        {block.heading && (
					        <SpecialText text={block.heading} />
                        )}
					</h1>
                </div>
                <div className={`l-grid__col l-grid__col--m-7-12 l-grid__col--l-6-12 l-grid__col--l-push-1-12`} >
                    <div className="scope-text scope-text--terms" dangerouslySetInnerHTML={{ __html: block.text || '' }} />
                </div>
            </div>
        </div>
    );
   
}